import { Injectable } from '@angular/core';
import { SpendingItem, SpendingTimelineDataItem } from './spending-timeline.types';
import { BudgetTimeframeDataItem } from '../widget.service';
import { Configuration } from 'app/app.constants';
import { TableColumnId } from '../../manage-ceg-table/components/manage-ceg-table-container/manage-ceg-table-container.enum';

@Injectable()
export class SpendingTimelineService {

  constructor(private configuration: Configuration) {}

  public convertRawDataToToSpendingTimelineData(
    data: BudgetTimeframeDataItem[],
    isManageTableTimeline = false,
    tableConfig: TableColumnId[] = [],
    cegFlagEnabled = false
  ): SpendingTimelineDataItem[] {
    const isMonthlyBudget = data.length === 12;

    if(isManageTableTimeline && !tableConfig.includes(TableColumnId.Budget)) {
      data.forEach(item => {
        item.total = item?.forecast || item.total;
        delete item.forecast;
      })
    }

    const timelineData = data?.map(rawDataItem =>
      this.convertRawDataItemToSpendingTimelineDataItem(rawDataItem, isMonthlyBudget, tableConfig, cegFlagEnabled)
    ) || [];

    const maxAmount = timelineData.reduce(
      (max, item) => Math.max(max, item.budget, item.totalSpent),
      0
    );

    timelineData.forEach(item => item.maxAmount = maxAmount);

    return timelineData;
  }

  private convertRawDataItemToSpendingTimelineDataItem(
    rawDataItem: BudgetTimeframeDataItem,
    isMonthlyBudget: boolean,
    tableConfig: TableColumnId[] = [],
    cegFlagEnabled = false
  ): SpendingTimelineDataItem {
    const budget = rawDataItem.total ?? 0;
    let totalSpent = 0;

    if (cegFlagEnabled) {
      if (tableConfig.includes(TableColumnId.Planned)) {
        totalSpent = (rawDataItem.spent || 0) + (rawDataItem.committed || 0) + (rawDataItem.planned || 0);
      } else if (tableConfig.includes(TableColumnId.Actual) && tableConfig.includes(TableColumnId.Committed)) {
        totalSpent = (rawDataItem.spent || 0) + (rawDataItem.committed || 0);
      } else if (tableConfig.includes(TableColumnId.Forecast) && tableConfig.includes(TableColumnId.Actual)) {
        totalSpent = (rawDataItem.spent || 0) + (rawDataItem.forecast || 0);
      } else if (tableConfig.includes(TableColumnId.Actual)) {
        totalSpent = (rawDataItem.spent || 0);
      } else if (tableConfig.includes(TableColumnId.Forecast)) {
        totalSpent = (rawDataItem.forecast || 0);
      }
    } else {
      totalSpent =
        (rawDataItem.closed || 0) +
        (rawDataItem.spent || 0) +
        (rawDataItem.committed || 0) +
        (rawDataItem.planned || 0) +
        (rawDataItem.under_budget || 0);
    }

    const spendingData: SpendingItem[] = [
      { id: 'remaining', val: budget > totalSpent ? budget - totalSpent : 0 },
      { id: 'planned', val: rawDataItem.planned || 0 },
      { id: 'committed', val: rawDataItem.committed || 0 },
      { id: 'closed', val: rawDataItem.closed || 0 },
      { id: 'under-budget', val: cegFlagEnabled ? 0 : rawDataItem.under_budget || 0 },
      { id: 'spent', val: rawDataItem.spent || 0 },
      { id: 'forecast', val: rawDataItem.forecast || 0 }
    ];

    const title = isMonthlyBudget
      ? this.configuration.getShortMonthName(rawDataItem.company_budget_alloc_name)
      : rawDataItem.company_budget_alloc_name;

    return {
      id: rawDataItem.company_budget_alloc_id,
      title,
      spending: spendingData,
      totalSpent,
      budget,
      overSpend: totalSpent > budget ? totalSpent - budget : 0,
      maxAmount: 0,
      isLocked: rawDataItem.locked
    };
  }
}
